import getOption from './getOption';

export default function getDefaultSorting(reverse = false): string {
  const prefix = reverse ? '' : '-';
  return getOption('HAS_AUCTIONS')
    ? `${prefix}ad_auction.time_start`
    : `${prefix}published`;
}
